import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Balloon } from '@alicloud/console-components';
import { tooltipPopupClassName, originalContentClassName } from './constants';
export function useTooltip(_ref) {
  var showTooltip = _ref.showTooltip,
      tooltipMaxWidth = _ref.tooltipMaxWidth,
      align = _ref.align,
      originalContent = _ref.originalContent,
      truncatedContent = _ref.truncatedContent;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var popupStyle = {};

  if (showTooltip && typeof tooltipMaxWidth === 'number' && tooltipMaxWidth > 0) {
    popupStyle.maxWidth = tooltipMaxWidth;
  }

  return (// TODO: 提供选项给用户自定义Ballon的各种属性，比如弹层容器
    React.createElement(Balloon, {
      visible: visible,
      trigger: truncatedContent,
      onVisibleChange: function onVisibleChange(newVisible) {
        if (showTooltip && newVisible) setVisible(true);else setVisible(false);
      },
      align: align,
      popupStyle: popupStyle,
      popupClassName: tooltipPopupClassName,
      alignEdge: true,
      needAdjust: true
    }, React.createElement("span", {
      style: {
        display: 'inline-block'
      },
      className: originalContentClassName
    }, originalContent))
  );
}